import React from 'react'

interface User {
    id: string
    [key: string]: any
}

interface UserListDisplayProps {
    users: User[]
    displayStyle?: 'avatar' | 'both' | 'text'
    userDisplay: (user: User) => React.ReactNode
}

export const UserFieldShow: React.FC<UserListDisplayProps> = ({
    users,
    displayStyle = 'text',
    userDisplay,
}) => {
    if (!users || users.length === 0) return null

    if (users.length === 1) {
        return (
            <span>
                <a
                    className={displayStyle === 'avatar' ? 'user-link' : ''}
                    href={`/user/${users[0].id}`}
                >
                    {userDisplay(users[0])}
                </a>
            </span>
        )
    }

    return (
        <ul>
            {users.map((item) => (
                <li style={{ listStyle: 'none' }} key={item.id}>
                    <a
                        className={displayStyle === 'avatar' ? 'user-link' : ''}
                        href={`/user/${item.id}`}
                    >
                        {userDisplay(item)}
                    </a>
                </li>
            ))}
        </ul>
    )
}
